<template>
    <div>
        <nav class="navbar navbar-expand-xl">
            <div class="container-fluid h-100">
                <a @click="IrALogin()" class="navbar-brand title-nombre" style="cursor: pointer;">Velvet System</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample06" aria-controls="navbarsExample06" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>
        </nav>

        <section class="container">
            <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <CLoader :pConfigLoad="ConfigLoad">
                        <template slot="BodyFormLoad">
                            <div class="card">
                                <div class="card-body">
                                    <div v-if="Visible && VisibleCoordinador" class="row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <button @click="IrAEncuesta()" class="btn btn-primary" type="button">Contestar Encuesta</button>
                                        </div>
                                    </div>

                                    <div v-if="!Visible" class="row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <h4>{{ TxtDefault }}</h4>
                                            <button @click="IrALogin()" class="btn btn-primary" type="button">Ir a Login</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </CLoader>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';
export default {
    name:'ResponderEncuesta',
    props:[''],
    data() {
        return {
            ConfigLoad:{
				ShowLoader: true,
				ClassLoad:  false,
			},
            MasterKey:'',
            MasterId:'',
            SendDate:'',
            Rol:'',
            TxtDefault:'Lo sentimos pero el link no es válido o ya expiro, por favor solicite una nueva encuesta.',
            Visible:true,
            VisibleParejas:false,
            VisibleCoordinador:false
        }
    },
    methods: {
        ValidaToken(){
            let request={
                Key:this.MasterKey,
                Id:this.MasterId,
                KeyNum:this.MasterNum,
                Rol:this.Rol
            }
            let formData=new FormData();
            formData.set('Key',this.MasterKey);
            formData.set('Id',this.MasterId);
            formData.set('KeyNum',this.MasterNum);
            formData.set('Rol',this.Rol);
            this.$http.post('configEncuestasValidar',formData
            ).then((res)=>{
                console.log(res);
                if (res.data.status) {
                    this.Visible=true;
                    if (this.Rol=='COORDINADOR') {
                        this.VisibleCoordinador=true;
                    }
                    else{
                        this.VisibleParejas=true;
                        this.ConfigLoad.ShowLoader=false;
                    }
                }
                else{
                    this.TxtDefault=res.data.message;
                }
            }).catch((err)=>{
                console.log(err);
                this.Visible=false;
                // this.TxtDefault=err.response.data.message;
                this.ConfigLoad.ShowLoader=false;
            })
        },
        IrAEncuesta(){
            if (this.Rol=='COORDINADOR') {
                this.$route.push({name:'encuestaResueltaCoordinador',params:{Id:0}});
            }
        },
        IrALogin(){

        }
    },
    created() {
        this.MasterKey=this.$route.params.key;
        this.MasterId=this.$route.params.id;
        this.MasterNum=this.$route.params.num;
        this.Rol=this.$route.params.rol;
        this.ValidaToken();
    },
}
</script>

<style>

</style>